import getMessage from 'src/background/utils/i18n.utils';
import React from 'react';
import { connect } from 'react-redux';
import { CustomTooltip } from 'src/common-ui/custom-tooltip/custom-tooltip.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
const ResourceItem = ({ icon, label, value, tooltipText, secondaryValue, ariaLabel, additionalClass, onClick, }) => {
    const handleOnClick = () => {
        if (onClick) {
            onClick();
        }
    };
    return (React.createElement(CustomTooltip, { dataTestId: `custom-tool-tip-${label}`, message: tooltipText, position: "bottom", skipTranslation: true },
        React.createElement("div", { "data-testid": ariaLabel, className: `resource-item ${additionalClass !== null && additionalClass !== void 0 ? additionalClass : ''} ${tooltipText ? 'has-tooltip' : ''} ${onClick ? 'clickable' : ''}`, onClick: handleOnClick },
            React.createElement(SVGIcon, { className: "icon", icon: icon }),
            React.createElement("div", { className: "right-panel" },
                React.createElement("div", { className: "top" },
                    React.createElement("div", { className: "label" }, getMessage(label))),
                React.createElement("div", { className: "bottom" },
                    value,
                    ' ',
                    secondaryValue && (React.createElement("span", { className: "secondary-value" }, secondaryValue)))))));
};
const mapStateToProps = (state) => {
    return {};
};
const connector = connect(mapStateToProps, {});
export const ResourceItemComponent = connector(ResourceItem);
